<template>
    <div>
        <!-- section-考试类别 -->
        <section class="section-grade-type section" style="padding-top: 0;">
            <div class="container">
                <div class="exam-introduce-box intro">
                    <h3 class="heading-tertiary">TDA-G10介绍</h3>
                    <div class="exam-introduce color-area-one">
                        <div class="exam-introduce-title">考试定位</div>
                        <div class="exam-introduce-text">
                            TDA-G10
                            聚焦高中起点，是考查高中学习所必备的学科基础知识、基本能力与学科素养为主的诊断性测试，帮助学生精准诊断学科基础的扎实程度，适应高中阶段的学习要求与思维模式。
                        </div>
                    </div>
                    <div class="exam-introduce color-area-two">
                        <div class="exam-introduce-title">考试目的</div>
                        <div class="exam-introduce-text">旨在通过对学生在高中学习阶段必备的学科基础知识、能力的综合考查，为学生提供精准的学科水平评估。</div>
                    </div>
                </div>
                <div class="exam-introduce-box intro">
                    <h3 class="heading-tertiary">基本信息</h3>
                    <div class="exam-introduce-grid">
                        <div class="exam-introduce color-area-one">
                            <div class="exam-introduce-list">
                                <span>面向群体：</span>准高一和高一学生
                            </div>
                            <div class="exam-introduce-list">
                                <span>报名方式：</span>支持以个人和中学为单位报名
                            </div>
                            <div class="exam-introduce-list">
                                <span>考试形式：</span>线上机考
                            </div>
                        </div>
                        <div class="exam-introduce color-area-two">
                            <div class="exam-introduce-list">
                                <span>科目设置：</span>语文、英语、数学、理科综合
                            </div>
                            <div class="exam-introduce-list">
                                <span>考查范围：</span>针对初高衔接以及高一年级基础部分知识点
                            </div>
                            <div class="exam-introduce-list">
                                <span>数据服务(学生)：</span>成绩报告、认证成绩单(仅限线上机考)
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section" id="section-intro">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">TDA试题特点</span>
                    </p>
                </h2>

                <!-- TDA常规科目试题介绍 -->
                <div class="normal-subject-dev-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">01 </span>-->
                        <span class="intro-title-text">科目精准诊断初高衔接，为学生提供适应性评估</span>
                    </h3>
                    <div class="intro-content">
                        <div class="normal-subject-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>科目</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA-G10 适用于准高一和高一学生，旨在诊断学科基础水平，帮助学生为高中学涯奠定坚实基础。试题命制以普通高中课程方案和各个学科课程标准为依据，重点考查高中学习所必备的学科基础知识、基本能力与核心素养，试题难度适中，注重基础性与适应性，帮助学生精准诊断学科基础扎实程度，顺利适应高中阶段的学习要求与思维模式。</span>
                                        <span class="paragraph">命题专家团队是高质量命题的基本保障，拥有近 200 名成员，具备十年以上教学经验，五届以上高三教学经验，并参与过多次省、市、区级大规模考试原创命题工作。</span>
                                    </p>
                                    <!--<div class="subject-resource">
                                        <p class="tips">
                                            *点击按钮直接下载科目样卷或扫描二维码购买历史真题
                                        </p>
                                        <a
                                                href="https://www.cssat.cn/example/常规科目样卷.zip"
                                                class="btn btn--full btn--download btn--link"
                                        >
                                            <span>下载科目样卷</span>
                                            <i
                                                    class="ph-bold ph-download-simple icon--download"
                                            ></i>
                                        </a>
                                        <img
                                                class="subject-excercise-qrcode"
                                                src="../../assets/img/tda-dev/subject-excercise-qrcode.png"
                                                alt="历史试卷购买网页二维码"
                                        />
                                    </div>-->
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">高考诊断试题特点</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">价值引领</p>
                                        <p class="service-feature-text">
                                            试题体现正确的政治方向和价值取向，引导学生形成正确的世界观、人生观和价值观
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考查全面</p>
                                        <p class="service-feature-text">
                                            试题内容符合新高考趋势，对学生学科素养、关键能力和必备知识进行全面考查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">科学性和时代性</p>
                                        <p class="service-feature-text">
                                            试题结合当前社会、科技、文化发展，考查对新知识和技能的掌握和应用能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">基础性和综合性</p>
                                        <p class="service-feature-text">
                                            试题涵盖高中段基础知识，同时考查综合运用知识解决实际问题的能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">应用性和创新性</p>
                                        <p class="service-feature-text">
                                            试题中设计实际应用场景，考查学生创新能力和运用理论知识解决问题能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">情境设计</p>
                                        <p class="service-feature-text">
                                            试题融入生活、学习等实际情境，考查学生在具体情境中运用知识解决问题能力
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TDA加试科目试题介绍 -->
                <div class="addition-subject-dev-intro intro">
                    <div class="intro-content">
                        <div class="cbt-sectinon intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>线上机考服务</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">线上机考模式由于其更大程度保障了考试严肃性且实施更便利等特点，正被越来越多高水平大学“强基计划”及其他各类“大学校考”采用。为让考生更熟悉线上机考形式，TDA除提供线下纸笔考试形式，还提供线上机考形式。</span>
                                        <span class="paragraph">TDA线上机考遵循严肃性“大学校考”实施框架，并由于其最大程度保障了<a
                                                class="text-link text-link--cbt"
                                                href="#supplement-features-cbt"
                                        ><i class="ph ph-link text-icon"></i
                                        >评估结果可靠和有效性</a
                                        >，对于线上机考考生支持<a
                                                class="text-link text-link--cbt"
                                                href="#certification-intro"
                                        ><i class="ph ph-link text-icon"></i>认证成绩单申请</a
                                        >。
                      </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">高严肃性考试实施</span>
                    </p>
                </h2>

                <!-- 成绩保障介绍 -->
                <div class="implement-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">03 </span>-->
                        <span class="intro-title-text">高严肃性考试实施标准，保障评估结果可信、有效</span>
                    </h3>
                    <div class="intro-content">
                        <div class="procedure-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>高严肃性标准化考试实施</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA采用高严肃性考试实施标准，通过对内标准化保障机制、对外标准化实施指引、信息技术、人工智能等多种手段，系统性保障考试试题质量、考试安全性、稳定性、公平性和数据可靠性，从而让评估结果具备更高可信度和有效性。</span>
                                    </p>
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">标准化考试服务保障</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题质量保障</p>
                                        <p class="service-feature-text">
                                            题目命制严格遵循"命、审、校(初)、排、校(终)"流程，分工明确，且试题均经过严格的原创性检查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题安全保障</p>
                                        <p class="service-feature-text">
                                            制题人员签订保密协议，制题全程采用"背对背"原则，且试题与答题卡均采用带密码锁的保密袋(箱)运输
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">实施质量保障</p>
                                        <p class="service-feature-text">
                                            为中学各类实施角色提供针对性的、明晰的实施指引，并采用信息化管理系统对考试全流程进行管理
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考试公平性保障</p>
                                        <p class="service-feature-text">
                                            统一发放保密袋(箱)开锁密码和机考开考密钥确保统一开考，阅卷采用线上"联考联阅"模式
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">数据可靠性保障</p>
                                        <p class="service-feature-text">
                                            对报名、参试、扫描等数据进行校验和确认，并对成绩进行多轮自动化检查和5‰随机抽样手工核对
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="supplement" id="supplement-features-cbt">
                            <p class="supplement-title">采用多种技术手段增强机考成绩质量</p>
                            <div class="cbt-procedure-section intro-section">
                                <div class="cbt-features service-features">
                                    <ul class="cbt-feature-list">
                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多种加密算法对机考电子化试题加密</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多层加密进行数据安全传输防攻击措施</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考全程实时监控，确保考试过程可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考系统自动屏蔽与考试无关的应用程序</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考软件锁屏、支持自动抓取切屏画面和预警</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>答案多途径回收、一致性检查兼防篡改校验</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>考生作答完整行为数据实时保存，考后可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="img-box">
                                    <img
                                            class="cbt-procedure-img"
                                            src="../../assets/image/relationship.png"
                                            alt="真实的机考实施相关图片"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">认证成绩单</span>
                    </p>
                </h2>

                <!-- 认证成绩单介绍 -->
                <div class="certification-intro intro" id="certification-intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">04 </span>-->
                        <span class="intro-title-text">考试成绩认证，供学生向成绩采信方提交成绩证明</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>认证成绩单(仅限线上机考)</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            参加TDA线上机考的考生可在学生系统中申请认证成绩单。认证成绩单是TDA考试的防伪成绩证明，可向成绩采信方提交。认证成绩单分为纸质版和电子版两种，申请成功后两种形式可同时获取。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">认证成绩单</p>
                                        <p class="service-feature-text">
                                            认证成绩单是针对线上机考考生的官方成绩证明，主要体现考生成绩及各地域范围内的排名数据。纸质认证成绩单选用优质纸张、印刷清晰、包装精致。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/image/TDA/reportPaper-G10.png"
                                            alt="认证成绩单与包装示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩数据验证</p>
                                        <p class="service-feature-text">
                                            每份成绩单均设有唯一的认证二维码和认证编号，使用者可通过<a
                                                class="text-link text-link--cbt"
                                                href="https://yanzheng.cssat.cn/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                        ><i class="ph ph-link text-icon"></i>官方验证网站</a
                                        >对成绩数据进行验证，有效防伪，确保成绩数据的真实性和可靠性。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/img/tda-cert/validation.png"
                                            alt="成绩单数据验证网站示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">数据报告</span>
                    </p>
                </h2>

                <!-- 数据分析报告介绍 -->
                <div class="data-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!-- <span class="intro-title-number">05 </span>-->
                        <span class="intro-title-text">客观排名成绩报告，你的实力一目了然</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>成绩报告</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            参加TDA-G10的考生可获得考试成绩报告，报告呈现了总分和各科成绩以及对应的全国百分比排名数据。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical" style="grid-template-rows: 1fr;">
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/TDA/report_1.jpg"
                                            alt="学生考试成绩报告示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical" style="grid-template-rows: 1fr;">
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/TDA/report_2.jpg"
                                            alt="学生考试成绩报告示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-参加TDA -->
        <section class="section-procedure section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--procedure">
                    <p class="section-title">
                        <span class="section-title-text">参加诊断性测试(TDA)</span>
                    </p>
                </h2>
                <div class="section-content">
                    <h3 class="heading-tertiary">个人参试</h3>
                    <!-- 个人参试 -->
                    <div class="procedure-subsection">
                        <div class="signUp-entrance-process">
                            <h3 class="heading-sixth">报名入口</h3>
                            <div class="signUp-entrance-info">您可以选择以下任意一种方式进行报名：</div>
                            <div class="signUp-entrance-box">
                                <div class="signUp-entrance-box-title">官方网站</div>
                                <div class="entrance-process-text">
                                    在本网站内点击【学生登录】，使用个人账号密码登录。如无账号，请先完成新用户注册。登录后，进入考试列表页面，选择您想要参加的考试进行报名。
                                </div>
                            </div>
                            <div class="signUp-entrance-box">
                                <div class="signUp-entrance-box-title">微信服务号</div>
                                <div class="entrance-process-text">扫描网站底部"CSSAT
                                    微信服务号二维码"，关注"标准学术能力测试"。点击底部菜单栏【服务】→【考试报名】进入考试列表页面，选择您想要参加的考试进行报名。
                                </div>
                            </div>
                        </div>
                        <!--<div class="signUp-entrance-process">
                            <h3 class="heading-sixth">报名流程（以微信服务号为例）</h3>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-one signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    <div>点击服务号底部菜单【服务】→【考试报名】。</div>
                                    <div class="disc">已参加过 CSSAT 序列考试的考生，可使用身份证号及密码登录（初始密码为身份证后 6 位，如最后一位为 X，请大写）。</div>
                                    <div class="disc">未参加过 CSSAT 序列考试的考生需先注册新用户后再登录。</div>
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-two signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    进入考试列表，在对应的考试名称后点击【立即报名】。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-three signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    填写邀请码（如无邀请码可直接点击【下一步】）。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-four signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    在下拉列表中选择考点城市后点击【预定】，考点城市支持跨省市选择及报名。若考点城市名额已满，可点击【申请候补】进行考位候补。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-five signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    在"确认报名信息"页面点击【立即支付】完成报名。如需更换考点城市，请在支付前点击【取消预定】返回上一步。
                                </div>
                            </div>
                            <div class="signUp-process-box">
                                <i class="ph-bold ph-number-six signUp-process-box-num"></i>
                                <div class="entrance-process-text">
                                    支付完成后，即报名成功。
                                </div>
                            </div>
                        </div>
                        <div class="signUp-entrance-process">
                            <h3 class="heading-sixth">注意事项</h3>
                            <div class="signUp-matter-box">
                                <div class="entrance-process-text">
                                    <div class="disc">注册时如在学校列表中未找到所在学校，可发送邮件至 service@cssat.cn 说明情况并注明中学全称。</div>
                                </div>
                                <div class="entrance-process-text">
                                    <div class="disc">已支付后如需换考点城市，须在报名截止前退掉原考位再重新报名（热门省份的考位数量变化较快，可能存在退后无法再报名的风险）。</div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                    <h3 class="heading-tertiary">中学参试</h3>
                    <!-- TDA参与全流程 -->
                    <div class="procedure-subsection">
                        <h3 class="heading-sixth heading-sixth--mb">TDA参试与服务流程</h3>
                        <div class="procedure-subsection-content subsection-content">
                            <!-- step1 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-one step-number"></i>
                                    <span>考试报名</span>
                                </p>
                                <p class="step-content">
                                    在CSSAT中学系统中导入参试学生名单信息完成考试报名。如未获得中学系统的账号和密码，可填写<a
                                        class="text-link"
                                        href="#register-subsection"
                                ><i class="ph ph-link text-icon"></i>报名申请信息</a
                                >
                                    进行网上申请或直接<a class="text-link" href="#footer"
                                ><i class="ph ph-link text-icon"></i>联系考试项目组</a
                                >
                                </p>
                            </div>

                            <!-- step2 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-two step-number"></i>考前准备
                                </p>
                                <p class="step-content">
                                    接收考试项目组寄送的试卷、答题卡及其他相关物料，并阅读各角色考试实施指引熟悉相关实施操作。如参与线上机考，需提前按要求完成监控布置和考试软件准备
                                </p>
                            </div>

                            <!-- step3 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-three step-number"></i
                                    >考中实施
                                </p>
                                <p class="step-content">
                                    考前及时接收保密袋(箱)开锁密码、开袋(箱)获取并分发试卷和答题卡。如参加机考，需获取并公布开考密钥。考中认真监考，如遇异常与考试项目组沟通解决
                                </p>
                            </div>

                            <!-- step4 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-four step-number"></i>数据回传
                                </p>
                                <p class="step-content">
                                    考试结束后配合考试项目组完成答题卡扫描与上传。如参加机考，配合考试项目组完成考生机考作答数据回收，并在规定时间内向考试项目组上传本地监控录制视频文件
                                </p>
                            </div>

                            <!-- step5 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-five step-number"></i>线上阅卷
                                </p>
                                <p class="step-content">
                                    及时接收考试项目组分发的阅卷参考答案与评分标准、各科阅卷账号和密码，并在考后及时完成线上阅卷。如对答案有疑义，及时向考试项目组写邮件告知
                                </p>
                            </div>

                            <!-- step6 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-six step-number"></i
                                    >成绩与报告获取
                                </p>
                                <p class="step-content">
                                    考试当日内中学可获得客观题数据分析及完整试题解析。阅卷结束后当周获得成绩明细表格、各类分析报告。学生可获得考试分析报告或申请认证成绩单
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- TDA参与全流程 -->
                    <div class="register-subsection" id="register-subsection">
                        <div class="register-text-box">
                            <h2 class="heading-secondary">提交申请表进行考试报名申请</h2>
                            <p class="register-text">
                                TDA报名需在CSSAT中学系统中完成。如还未有系统账号和密码，请先填写并提交以下申请表或直接联系考试项目组获取。提交申请后，考试项目组会与你联系并向你提供相关账号和密码。如已有中学系统账号和密码，请直接<a
                                    class="text-link"
                                    href="#"
                            ><i class="ph ph-link text-icon"></i>进入中学系统进行报名</a
                            >。
                            </p>
                            <div class="register-form" name="sign-up">
                                <!-- 中学省份筛选 -->
                                <div class="form-item">
                                    <label for="school-province">中学省份:</label>
                                    <select
                                            v-model="formData.province_id"
                                            id="school-proince-selection"
                                            name="school-proince-selection"
                                            required
                                            :class="!formData.province_id?'no-value':''"
                                            @blur="validateProvince"
                                            @change="onChangeProvince"
                                    >
                                        <option value="">请选择中学省份</option>
                                        <option v-for="(item, index) in provinceList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="provinceErr" class="input-error">{{provinceErrMsg}}</span>
                                </div>

                                <!-- 中学城市筛选 -->
                                <div class="form-item">
                                    <label for="school-city">中学城市:</label>
                                    <select
                                            v-model="formData.city_id"
                                            id="school-city-selection"
                                            name="school-city-selection"
                                            required
                                            :class="!formData.city_id?'no-value':''"
                                            @blur="validateCity"
                                    >
                                        <option value="">请选择中学城市</option>
                                        <option v-for="(item, index) in cityList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="cityErr" class="input-error">{{cityErrMsg}}</span>
                                </div>

                                <!-- 中学名称筛选 -->
                                <div class="form-item">
                                    <label for="school">中学名称:</label>
                                    <input
                                            v-model="formData.school_name"
                                            id="school-selection"
                                            type="text"
                                            placeholder="请填写真实中学名称"
                                            name="school-selection"
                                            required
                                            @blur="validateSchool"
                                    />
                                    <span v-if="schoolErr" class="input-error">{{schoolErrMsg}}</span>
                                </div>

                                <!-- 联系人姓名 -->
                                <div class="form-item">
                                    <label for="name">联系人姓名:</label>
                                    <input
                                            v-model="formData.contact_person"
                                            id="input-name"
                                            type="text"
                                            placeholder="请填写真实联系人"
                                            name="input-email"
                                            required
                                            @blur="validatePerson"
                                    />
                                    <span v-if="contactPersonErr" class="input-error">{{contactPersonErrMsg}}</span>
                                </div>

                                <!-- 联系人邮箱 -->
                                <div class="form-item">
                                    <label for="email">联系邮箱:</label>
                                    <input
                                            v-model="formData.email"
                                            id="input-email"
                                            type="email"
                                            placeholder="请填写常用邮箱"
                                            name="input-email"
                                            required
                                            @blur="validateEmail"
                                    />
                                    <span v-if="emailErr" class="input-error">{{emailErrMsg}}</span>
                                </div>

                                <!-- 联系人电话 -->
                                <div class="form-item">
                                    <label for="phone">联系电话:</label>
                                    <input
                                            v-model="formData.contact_phone"
                                            id="input-phone"
                                            type="text"
                                            placeholder="请填写联系手机号或固话"
                                            name="input-phone"
                                            required
                                            @blur="validatePhone"
                                    />
                                    <span v-if="phoneErr" class="input-error">{{phoneErrMsg}}</span>
                                </div>

                                <button class="btn btn--form" @click="onApply()">提交申请</button>
                                <div class="register-dialog" v-if="errMsgShow">{{errMsg}}</div>
                            </div>
                        </div>
                        <div
                                class="register-img-box"
                                role="img"
                                aria-label="填写申请表的配图"
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {apply, getCityList, getProvinceList} from "@/request";

    export default {
        name: "TDA-G10",
        data() {
            return {
                loading: false,
                formData: {
                    province_id: '',
                    city_id: '',
                    school_name: '',
                    contact_person: '',
                    email: '',
                    contact_phone: '',
                    action: 'gw',
                },
                provinceErr: false,
                provinceErrMsg: '',
                cityErr: false,
                cityErrMsg: '',
                schoolErr: false,
                schoolErrMsg: '',
                contactPersonErr: false,
                contactPersonErrMsg: '',
                emailErr: false,
                emailErrMsg: '',
                phoneErr: false,
                phoneErrMsg: '',
                errMsgShow: false,
                errMsg: '',
                cityOption: {},
                provinceList: [],
                cityList: [],
            }
        },
        mounted() {
            this.getProvince();
            this.getCity();
        },
        methods: {
            // 邮箱正则
            ruleEmail(email) {
                let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                return emailRegex.test(email);
            },
            // 手机号|固话正则
            rulePhone(phone) {
                // 匹配手机号的正则
                const phoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\(?\d{3,4}\)?)\s*-?\s*(\d{3,4})\s*-?\s*(\d{4})$/;
                // 匹配固定电话的正则
                const fixedPhoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\d{3,4})\s*-?\s*(\d{3,4})$/;
                return phoneRegex.test(phone) || fixedPhoneRegex.test(phone);
            },
            validateProvince() {
                if (!this.formData.province_id) {
                    this.provinceErr = true;
                    this.provinceErrMsg = '请选择中学省份！';
                    return true;
                } else {
                    this.provinceErr = false;
                    this.provinceErrMsg = '';
                    return false;
                }
            },
            validateCity() {
                if (!this.formData.city_id) {
                    this.cityErr = true;
                    this.cityErrMsg = '请选择中学城市！';
                    return true;
                } else {
                    this.cityErr = false;
                    this.cityErrMsg = '';
                    return false;
                }
            },
            validateSchool() {
                if (!this.formData.school_name) {
                    this.schoolErr = true;
                    this.schoolErrMsg = '请填写真实中学名称！';
                    return true;
                } else {
                    this.schoolErr = false;
                    this.schoolErrMsg = '';
                    return false;
                }
            },
            validatePerson() {
                if (!this.formData.contact_person) {
                    this.contactPersonErr = true;
                    this.contactPersonErrMsg = '请填写真实联系人！';
                    return true;
                } else {
                    this.contactPersonErr = false;
                    this.contactPersonErrMsg = '';
                    return false;
                }
            },
            validateEmail() {
                if (!this.formData.email) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写常用邮箱！';
                    return true;
                } else if (!this.ruleEmail(this.formData.email)) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写正确格式的邮箱！';
                    return true;
                } else {
                    this.emailErr = false;
                    this.emailErrMsg = '';
                    return false;
                }
            },
            validatePhone() {
                if (!this.formData.contact_phone) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写联系手机号或固话！';
                    return true;
                } else if (!this.rulePhone(this.formData.contact_phone)) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写正确格式的手机号或固话！';
                    return true;
                } else {
                    this.phoneErr = false;
                    this.phoneErrMsg = '';
                    return false;
                }
            },
            // 提交申请
            async onApply() {
                let status = false;
                if (this.validateProvince()) {
                    status = true;
                }
                if (this.validateCity()) {
                    status = true;
                }
                if (this.validateSchool()) {
                    status = true;
                }
                if (this.validatePerson()) {
                    status = true;
                }
                if (this.validateEmail()) {
                    status = true;
                }
                if (this.validatePhone()) {
                    status = true;
                }
                if (status) return false;

                if (this.loading) return false;
                this.loading = true;

                let data = await apply(this.formData);
                this.errMsg = data.message;
                this.errMsgShow = true;
                setTimeout(() => {
                    this.errMsg = '';
                    this.errMsgShow = false;
                }, 3000)
                if (data.code != 200) {
                    this.loading = false;
                    return false;
                }
                this.loading = false;
                this.formData.province_id = '';
                this.formData.city_id = '';
                this.formData.school_name = '';
                this.formData.contact_person = '';
                this.formData.email = '';
                this.formData.contact_phone = '';
            },
            onChangeProvince() {
                this.formData.city_id = '';
                this.cityList = [];
                let pId = this.formData.province_id;
                let all_city = this.cityOption;
                let city_list = [];
                for (let key in all_city) {
                    if (pId == all_city[key]['parent_id']) {
                        city_list.push(all_city[key]);
                    }
                }
                this.cityList = city_list;
            },
            async getProvince() {
                let data = await getProvinceList();
                if (data.code != 200) return;
                this.provinceList = data.list;
            },
            async getCity() {
                let data = await getCityList();
                if (data.code != 200) return;
                this.cityOption = data.list;
            },
            downloadFile(name) {
                let href = parent.window.location.origin + '/example/' + name;
                console.log(href);
                window.location.href = href;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/main--tda.css';
    @import '../../assets/css/queries--tda.css';
    @import '../../assets/scss/main--tda.scss';
    @import '../../assets/scss/queries--tda.scss';

    .form-item {
        position: relative;
    }

    .input-error {
        position: absolute;
        top: 100%;
        left: 0;
        color: #f56c6c;
        font-size: 1.1rem;
        line-height: 1;
        padding-top: 0.4rem;
    }

    .register-form {
        position: relative;
    }

    .register-dialog {
        position: absolute;
        left: 50%;
        top: 60%;
        transform: translate(-50%, -50%);
        font-size: 1.2rem;
        background-color: #000000;
        padding: 1rem 1.2rem;
        border-radius: 0.6rem;
        opacity: 0.85;
    }

</style>
